import "../Styles/index.scss";

import { defineCustomElement as defineCustomElementCore, type App, type Component } from "vue";
import { ConfigProgrammatic, Button, Checkbox, Radio, Field, Input, Select, Notification, Modal, Switch, Loading } from "buefy";
import { Fancybox } from "@fancyapps/ui";
import Flickity from "flickity";

function defineAndConfigureCustomElement(component: any) {
	return defineCustomElementCore(component.__vccOpts, {
		shadowRoot: false,
		configureApp(app) {
			app.use(Field);
			app.use(Input);
			app.use(Checkbox);
			app.use(Radio);
			app.use(Button);
			app.use(Select);
			app.use(Switch)
			app.use(Loading);
			app.use(Notification);
			app.use(Modal);
		},
	})
}

document.querySelector(".header-nav-toggle")?.addEventListener("click", e => document.body.classList.toggle("is-nav-open"));

for (let element of document.querySelectorAll<HTMLElement>(".has-children .navigation__link.level-1")) {
	element.addEventListener("click", e => {
		let target = e.target as HTMLElement;
		let navItem = target.parentElement!;

		// toggle child container
		let container = navItem.querySelector(".navigation__container");
		container?.classList.toggle("is-open");

		// close all others
		for (let element of document.querySelectorAll(".navigation__container.is-open")) {
			if (element === container) {
				continue;
			}
			element.classList.remove("is-open");
		}

		e.preventDefault();
	});
}

for (let element of document.querySelectorAll<HTMLElement>(".navigation__link[href^='#']")) {
	element.addEventListener("click", e => {
		document.dispatchEvent(new CustomEvent("close-menu"));
	});
}

document.addEventListener("close-menu", () => {
	document.body.classList.remove("is-nav-open");
	for (let element of document.querySelectorAll(".navigation__container.is-open")) {
		element.classList.remove("is-open");
	}
});

// click outside menu to close
document.addEventListener("click", e => {
	let target = e.target as HTMLElement;
	if (!target.classList.contains("navigation__link") && target.closest(".navigation__container.is-open") == null) {
		document.querySelector(".navigation__container.is-open")?.classList.remove("is-open");
	}
});

Fancybox.bind(".asset.is-zoomable, .asset > img.is-zoomable", {
	theme: "light"
});

for (let element of document.querySelectorAll<HTMLAnchorElement>("a[href^='/api/employees/']")) {
	element.addEventListener("click", e => {
		e.preventDefault();
		Fancybox.show([
			{
				type: "ajax",
				src: element.href,
			}
		], {
			theme: "light"
		});
	});
}

let headerSliderElement = document.querySelector(".header-slider");
if (headerSliderElement != null) {
	new Flickity(headerSliderElement, {
		autoPlay: 4000,
		wrapAround: true,
		prevNextButtons: false,
		setGallerySize: false,
	});
}

let galleryElements = document.querySelectorAll<HTMLElement>(".asset-list--image");
for (let galleryElement of galleryElements) {
	new Flickity(galleryElement, {
		pageDots: false,
	});
}

if (document.querySelector("custom-form") != null) {
	import("./custom-form/custom-form").then(m => {
		customElements.define("custom-form", defineAndConfigureCustomElement(m.CustomForm));
	});
}
